import { render, staticRenderFns } from "./dailySpeakingPage.vue?vue&type=template&id=37b5b6cb&scoped=true&"
import script from "./dailySpeakingPage.vue?vue&type=script&lang=js&"
export * from "./dailySpeakingPage.vue?vue&type=script&lang=js&"
import style0 from "./dailySpeakingPage.vue?vue&type=style&index=0&id=37b5b6cb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b5b6cb",
  null
  
)

export default component.exports